import React from 'react';
import { Placement } from '@floating-ui/react';
import { SvgIcon } from '../Icon';
import { ITooltipOption } from '../KubitTooltip/globalTooltips';
import { IStyled } from '../../styles/types';
import { theme } from '../../styles/theme';
import KubitTooltip from '../KubitTooltip';

interface IProps extends IStyled {
  tooltipOption: ITooltipOption;
  placement?: Placement;
  size?: number;
}

const InformationalTooltip = ({
  tooltipOption,
  placement,
  size = 16,
  className,
}: IProps) => {
  return (
    <KubitTooltip {...tooltipOption} placement={placement || 'top'}>
      <SvgIcon
        name="info"
        width={size}
        height={size}
        customFill={theme.colors.secondary800}
        isHoverable
        className={className}
      />
    </KubitTooltip>
  );
};

export default InformationalTooltip;
